import React from "react"
import {useState} from "react";
import UnloadingItemContent from "./unloading-item-content"
import {Spin} from "antd"
import {
  UNLOADING_CANCELED,
  UNLOADING_COMPLETED,
  UNLOADING_NOT_PLANNED, UNLOADING_ON_UNLOADING,
  UNLOADING_PLANNED
} from "../../helpers/unloading_status.helper";

export default function UnloadingItemBlock({
                                             unloading,
                                           }) {
  // Может быть позже скрытый элемент для доп инфы нужен будет
  const [contentVisible, setContentVisible] = useState(false);

  let statusClass = '';

  switch (unloading.Status) {
    case UNLOADING_COMPLETED:
      statusClass = ' application-item-green';
      break;

    case UNLOADING_CANCELED:
      statusClass = ' application-item-red';
      break;

    default:
      statusClass = ' application-item-blue';
      break;

  }


  return (
    <div className={`application-item${statusClass}`}>
      {UnloadingItemContent({unloading, contentVisible, setContentVisible})}
    </div>
  )
}